import { ISlotegratorServerGame } from '../../types/interfaces/Slots/Slotegrator';

const crashGamesIds = [
  '9eee9764948c4c300c1c575b7fdb36d0478a016e',
  '2dba096b6001e9230e46a4bfa13577f17ebcaf43',
  'b0b5133729ad04360a1c33bce7f2c4febc5ef993',
];

const xMasIds = [
  // KAgaming
  '4981bee599d2406c8a5fb23528b06f47',
  '1b7c704fb9724c36b72da9301232589d',
  // mobile  xMas
  '7684cd0a7d52429e9d826c847c0e972f',
  'f5d5570495c34b0e977a0c3e5c28dc09',

  // Endorphina
  // mobile xMas
  '7e4352eb49dad04b797ce6b1c6a2e99dcd378f74',
  '3bd9466c3f946b09306ebeda409715d364582cda',
  '9c2e89f3d4842b353db4f3de2776ffc6e1995f1a',
  '07168592711de9e8a6d15ec97f31e84e4e15615b',
  '20894663ab31be090d552d1f9fc2d83b5fd1a7b5',
];

// const popularKagamingIdsDesktop = [
//   // desktop
//   '638f05823691435c84a66354a707924b', // Hot Coin
//   '1aed5aff45034535856144ccd029b1c7', // Red Sorghum
//   '553000ad92ff4b7aa73eac11622b1616', // Irish Coins
//   '929db10eb2af4269a2a49b22101dfc41', // Red Riding Hood
//   '4c9c52aa1f1149aca2e07ab36703910e', // 777 Vegas
//   'cc35f1e4506945c7b4c4a43841652228', // Scary Clown
//   'c019dfb6372f46b0982f1d1651968610', // Lady KAKA
//   '0b1081c6ea174d8e884a7ae1062ed30d', // Tai Chi
//   'f7782554f02240b49f5e1af8152c2671', // Fruit Party

//   // mobile
//   '3331dc006cd645d387e2756554efc558', // Hot Coin
//   '99233ebed020400d9354d6d7ac68abec', // Red Sorghum
//   '871af472448a4834af8dec8f3dd25095', // Irish Coins
//   '74596d7affcb434090b523c8009f2c5b', // Red Riding Hood
//   'ddc560b77ea9457fae0ebd9b44f97dc2', // 777 Vegas
//   'fff4e44c5f974323bec49de632ec4950', // Scary Clown
//   'e9fd361c8ce046e7a5d1027414d3b9c6', // Lady KAKA
//   '0ce2daad8f984f6d8836088cb23af191', // Tai Chi
//   '5ba72166ebb64b069a7430a6dfe621a6', // Fruit Party
// ];

const bingoIds = ['6103712a2f1d4092a340abd297362beb', 'af38817ad86148b194ae68fcf7d410f6'];

const getTab = (tab: string, id: string) => {
  const tabs = [];
  if (
    tab === 'slots' ||
    tab === 'slot' ||
    tab === 'keno' ||
    tab === 'fish/shooting' ||
    tab === 'cluster' ||
    tab === 'other' ||
    tab === 'fruit game' ||
    tab === 'virtual'
  )
    tabs.push('slotMachines');
  if (tab === 'baccarat' || tab === 'roulette' || tab === 'provably fair' || tab === 'table') tabs.push('roulette');
  if (tab === 'blackjack' || tab === 'poker') tabs.push('cardGames');
  if (tab === 'lottery') tabs.push('lotto');
  if (crashGamesIds.indexOf(id) !== -1) tabs.push('crash');
  if (xMasIds.indexOf(id) !== -1) tabs.push('xMas');
  if (bingoIds.indexOf(id) !== -1) tabs.push('bingo');
  return tabs;
};

const filterTab = (game: ISlotegratorServerGame, tabs: string[]) => {
  switch (game.provider.toUpperCase()) {
    case 'BETSOLUTIONS':
      return tabs.filter(type => type !== 'roulette');
    case 'KAGAMING':
      // if (popularKagamingIdsDesktop.includes(game.uuid)) {
      //   return [...tabs, 'popular'];
      // }

      if (game.uuid === '54a421fa87f741a6b432401ae90608d3') {
        return [...tabs.filter(type => type !== 'roulette'), 'cardGames'];
      }

      break;
    default:
      return tabs;
  }

  return tabs;
};

export { getTab, filterTab };
